export default {
  // 面包屑
  breadcrumb: {
    projectSettings: '设置',
    interviewSettings: '选考设置',
    interviewChannel: '申请渠道来源',
  },

  // 列表页
  pageTitle: '申请渠道来源',
  searchPlaceholder: '搜索渠道来源名称',
  createChannel: '添加渠道来源',
  channelName: '渠道来源',
  isEnabled: '是否启用',
  lastEditTime: '最近编辑时间',
  lastEditor: '最近编辑人',
  createTime: '创建时间',
  creator: '创建人',

  // 弹窗
  editChannel: '编辑渠道来源',
  channelNamePlaceholder: '请输入',
  enabledDescription: '已开启，新创建注册候选人时可选择此渠道来源',
  disabledDescription: '已关闭，新创建注册候选人时不可选择此渠道来源',
  addButton: '添加',
  saveButton: '保存',

  // 验证消息
  channelNameRequired: '请输入渠道来源名称',

  // 删除确认
  deleteConfirmTitle: '确认删除渠道来源',
  deleteConfirmWarnTitle: '暂不支持删除应聘渠道',
  deleteConfirmContent: '删除后不可恢复，确认删除渠道来源「{name}」吗？',
  deleteUsageWarningContent: '存在注册候选人使用此渠道来源，暂不支持删除。',

  // 启用/停用确认
  enableConfirmTitle: '确认启用渠道来源',
  enableConfirmContent: '启用后，新创建注册候选人时可选择此渠道来源。',
  enableButton: '启用',
  disableConfirmTitle: '确认停用渠道来源',
  disableConfirmContent: '停用后，新创建注册候选人时不可选择此渠道来源，已注册的候选人不受影响。',
  disableButton: '停用',

  // 空状态
  emptyStates: {
    noData: {
      title: '暂无渠道来源',
      description: '请先创建渠道来源',
    },
  },
};
